module.exports = __webpack_public_path__ + "static/building-a-brotherhood-c7e71ef5c0f3f0a22262d38603ddc8f3.jpg";